import React from 'react';
import { translate } from "react-translate";
import { withRouter } from "react-router-dom";
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import { Alert } from 'react-bootstrap';

class RegResultPage extends React.Component {

  getVariant(result) {
    return (result === 'success' ? 'success' : 'danger');
  }


  getMessage(result, type) {
    return (result === 'success' ? 'success' : 'fail')+type;
  }


  render() {
    return (
      <div>
        <Navbar commonProps={this.props.commonProps} />
        <div className="page regresult">
          <Alert className="capsFont" variant={ this.getVariant(this.props.match.params.result) }>
            { this.props.t(this.getMessage(this.props.match.params.result, this.props.match.params.type)) }
          </Alert>
        </div>
        <Footer />
      </div>
    );
  }

}

export default translate('RegResultPage')(withRouter(RegResultPage));
